<div class="container">
  <div class="wrapper">
    <h1 class="pageTitle" id="main-content" tabindex="-1">
      {{ pageTitle }}
    </h1>
    <h2 class="govuk-heading-m">{{ verifyPageText }}</h2>
    @if(webhookResponseStatus) {
      <p class="govuk-body-l">{{ webhookResponseStatus | translate }}</p>
    }


    <ng-container *ngIf="maxRetriesReached || paymentFailed || paymentAlreadyPaid">
      <div class="row pb-4">
        <div class="col-sm-12">
          <button type="submit" class="btn btn-primary return-button" (click)="restartJourney()">
            {{ 'CONFIRMATION.RETURN_HOME' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  @if(failed) {
    <div class="govuk-grid-column-two-thirds">
      <h1 class="govuk-heading-l">Sorry, there has been a problem</h1>
      <p class="govuk-body">Try again later.</p>
      <p class="govuk-body">Charge ID: {{ chargeId }}</p>
      <p class="govuk-body">Receipt: {{ receipt }}</p>
      <p class="govuk-body">Internal ref: {{ ref }}</p>
      <button type="submit" class="btn btn-primary return-button" (click)="restartJourney()">
        {{ 'CONFIRMATION.RETURN_HOME' | translate }}
      </button>
    </div>
  }
</div>

